import parseQuery from 'tools/parseQuery';

type GenerateUrlParams = {
    url: string;
    append?: string;
    custom?: string;
    tableauTabsInd?: string;
    useCustomTail: boolean;
    tableauToolbar?: string;
};

const joinParsedString = (result: { [key: string]: string } = {}): string => {
    const values = [];
    for (var i in result) {
        if (!result.hasOwnProperty(i) || 'function' === typeof result[i]) continue;
        values.push(decodeURIComponent(i) + '=' + decodeURIComponent(result[i] || ''));
    }

    return values.join('&');
};

export const generateFullURL = ({
    url = '',
    append,
    tableauToolbar = '',
    custom,
    tableauTabsInd,
    useCustomTail,
}: GenerateUrlParams): {
    fullUrl: string;
    settingAppend: string;
} => {
    let fullUrl = url + custom;
    const result = parseQuery(append);
    let settingAppend = '';

    if (useCustomTail && append) {
        result[':toolbar'] = tableauToolbar;
        result[':tabs'] = tableauTabsInd === 'Y' ? 'yes' : 'no';
        fullUrl += (-1 == fullUrl.indexOf('?') ? '?' : '&') + joinParsedString(result);
        settingAppend = joinParsedString({
            ':toolbar': result[':toolbar'],
            ':tabs': result[':tabs'],
        });
    } else {
        fullUrl += (-1 == fullUrl.indexOf('?') ? '?' : '&') + append;
    }

    return {
        fullUrl,
        settingAppend,
    };
};

export const getTails = (prevUrl: string = '', url = ''): string => {
    return prevUrl?.replaceAll(url, '');
};

export const formatUrl = (url = ''): string => {
    let result = url.replace(/&amp;/g, '&');
    if (result.endsWith('&')) {
        result = result.slice(0, -1);
    }
    if (result.endsWith('?')) {
        result = result.slice(0, -1);
    }
    return result;
};

export const getUrlAppend = (reportDisplay: string, data: any): string => {
    const params =
        (reportDisplay === 'external' ? data.report_url_external_page_append : data.report_url_viewer_append) || '';
    return formatUrl(params);
};
